import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes } = actionCreation;

export const getChangeRequestActionTypes = generateActionTypes('GET_CHANGE_REQUESTS');

export const getChangeRequest = () => ({ type: getChangeRequestActionTypes.common });

export const getChangeRequestRequest = () => ({ type: getChangeRequestActionTypes.request });

export const getChangeRequestSuccess = (data) => ({
  type: getChangeRequestActionTypes.success,
  ...data,
});

export const getChangeRequestError = (error) => ({
  type: getChangeRequestActionTypes.error,
  error,
});

export const sendChangeRequestActionTypes = generateActionTypes('POST_CHANGE_REQUESTS');

export const sendChangeRequest = (transactionId, requestType) => ({
  type: sendChangeRequestActionTypes.common,
  transactionId,
  requestType,
});

export const sendChangeRequestRequest = () => ({ type: sendChangeRequestActionTypes.request });

export const sendChangeRequestSuccess = (data) => ({
  type: sendChangeRequestActionTypes.success,
  ...data,
});

export const sendChangeRequestError = (error) => (
  {
    type: sendChangeRequestActionTypes.error,
    error,
  }
);
